<template>
  <div class="container series-container">
    <h1>{{ heading }}</h1>
    <div
      v-html="$store.state.initialData.seriesContent"
      class="txt"
      v-if="$route.name === `series`"
    ></div>
    <group-videos :items="seriesObjects"></group-videos>
    <div v-if="$route.name === `myseries`">
      <hr />
      <h2>הסדרות שלי</h2>
      <collection-list :items="videoCollections"></collection-list>
    </div>
  </div>
</template>

<script>
import GroupVideos from "@/components/series/GroupVideos.vue";
import CollectionList from "@/components/series/CollectionList.vue";

export default {
  name: `groupVideosPage`,

  components: {
    GroupVideos,
    CollectionList,
  },
  computed: {
    heading() {
      if (this.$route.name === `series`) {
        return `תוכניות אימונים`;
      }
      return `תוכניות האימונים שלי`;
    },

    seriesList() {
      if (this.$route.name === `series`) {
        // eslint-disable-next-line
        return this.$store.state.series.filter(item => item.parent === `10`);
      }
      return this.$store.state.user.mySeries;
    },

    seriesObjects() {
      if (this.$route.name === `myseries`) {
        const arr = this.$store.state.series.filter(s => {
          if (this.seriesList.indexOf(`${s.id}`) > -1 && s.parent === `10`) {
            return true;
          }
          return false;
        });
        return arr;
      }
      return this.seriesList;
    },

    videoCollections() {
      if (this.$route.name === `myseries`) {
        const arr = this.$store.state.series.filter(s => {
          if (this.seriesList.indexOf(`${s.id}`) > -1 && s.parent !== `10`) {
            return true;
          }
          return false;
        });
        return arr;
      }
      return this.seriesList;
    },

    isLoggedIn() {
      return this.$store.state.user.isLoggedIn;
    },
  },

  // created() {
  //   if (this.isLoggedIn === 0) {
  //     this.$router.push(`/profile`);
  //   }
  // },
};
</script>

<style lang="scss">
.series-container {
  h1 {
    margin: 20px 0;
    padding: 0 15px;
  }

  .columns {
    margin-right: 0;
  }
  h2 {
    font-size: 1.5rem;
    font-weight: 300;
    margin: 20px 0;
    padding: 0 15px;
  }
}
@media screen and (min-width: 1025px) {
  .series-container {
    h1,
    h2 {
      padding: 0;
    }
    .columns {
      margin-right: -0.75rem;
    }
  }
}
</style>

